import { CouponInfo, CouponState, MerchantState } from '../../type';

/** 优惠券详情 */
export type Coupon = CouponInfo & { isEmpty: boolean, isPlayAni: boolean, isGet: boolean, isDisabled: boolean };

/** 轮播商户信息 */
export type MchSpLogoList = {
  /** 商户logo */
  spLogo: string,
  /** 排序 */
  rank: string
};

/** 广告位类型 */
export enum AdType {
  /** 抢券有So商户展示券广告位类型 */
  spAd = 0,
  /** 自定义广告 */
  otherAd,
  /** 分享裂变券 */
  shareCouponAd,
};

export {
  CouponState,
  MerchantState,
};
